export function calculatePeriodPrice(period, basePrice, prices = {}) {
  const periodKey = period.toString()
  const priceFromApi = parseFloat(prices[periodKey])
  
  if (!isNaN(priceFromApi)) {
    return priceFromApi
  }
  
  return basePrice * period
}

export function calculatePrivacyPrice(period, enabled, privacyPricePerYear = 3.00) {
  if (!enabled) {
    return 0
  }
  return privacyPricePerYear * period
}

export function calculateTotalPrice(periodPrice, privacyPrice) {
  return periodPrice + privacyPrice
}

export function getPerYearPrice(totalPrice, period) {
  if (period === 0) return 0
  return totalPrice / period
}

// Generates a deterministic discount percentage (10-15%) based on domain name using a hash function
export function getDomainDiscount(domainName) {
  if (!domainName || typeof domainName !== 'string') {
    return 12.5;
  }

  let hash = 0;
  const normalizedDomain = domainName.toLowerCase();
  for (let i = 0; i < normalizedDomain.length; i++) {
    const char = normalizedDomain.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }

  const discountRange = 15 - 10;
  const discount = 10 + (Math.abs(hash) % 100) / 100 * discountRange;
  return Math.round(discount * 100) / 100;
}

export function calculateDiscountedPrice(originalPrice, discountPercent) {
  if (!originalPrice || originalPrice <= 0) return originalPrice;
  const discount = originalPrice * (discountPercent / 100);
  return originalPrice - discount;
}
